const colorSchemes = {
  "Apprentice": [
    "262626",
    "303030",
    "333333",
    "6C6C6C",
    "787878",
    "BCBCBC",
    "C9C9C9",
    "FFFFFF",
    "5F8787",
    "FF8700",
    "5F8787",
    "87AF87",
    "5F875F",
    "FFFFAF",
    "87AFD7",
    "5F87AF"
  ],
  "Atelier Cave Light": [
    "efecf4",
    "e2dfe7",
    "8b8792",
    "7e7887",
    "655f6d",
    "585260",
    "26232a",
    "19171c",
    "be4678",
    "aa573c",
    "a06e3b",
    "2a9292",
    "398bc6",
    "576ddb",
    "955ae7",
    "bf40bf"
  ],
  "Atelier Cave": [
    "19171c",
    "26232a",
    "585260",
    "655f6d",
    "7e7887",
    "8b8792",
    "e2dfe7",
    "efecf4",
    "be4678",
    "aa573c",
    "a06e3b",
    "2a9292",
    "398bc6",
    "576ddb",
    "955ae7",
    "bf40bf"
  ],
  "Atelier Dune Light": [
    "fefbec",
    "e8e4cf",
    "a6a28c",
    "999580",
    "7d7a68",
    "6e6b5e",
    "292824",
    "20201d",
    "d73737",
    "b65611",
    "ae9513",
    "60ac39",
    "1fad83",
    "6684e1",
    "b854d4",
    "d43552"
  ],
  "Atelier Dune": [
    "20201d",
    "292824",
    "6e6b5e",
    "7d7a68",
    "999580",
    "a6a28c",
    "e8e4cf",
    "fefbec",
    "d73737",
    "b65611",
    "ae9513",
    "60ac39",
    "1fad83",
    "6684e1",
    "b854d4",
    "d43552"
  ],
  "Atelier Estuary Light": [
    "f4f3ec",
    "e7e6df",
    "929181",
    "878573",
    "6c6b5a",
    "5f5e4e",
    "302f27",
    "22221b",
    "ba6236",
    "ae7313",
    "a5980d",
    "7d9726",
    "5b9d48",
    "36a166",
    "5f9182",
    "9d6c7c"
  ],
  "Atelier Estuary": [
    "22221b",
    "302f27",
    "5f5e4e",
    "6c6b5a",
    "878573",
    "929181",
    "e7e6df",
    "f4f3ec",
    "ba6236",
    "ae7313",
    "a5980d",
    "7d9726",
    "5b9d48",
    "36a166",
    "5f9182",
    "9d6c7c"
  ],
  "Atelier Forest Light": [
    "f1efee",
    "e6e2e0",
    "a8a19f",
    "9c9491",
    "766e6b",
    "68615e",
    "2c2421",
    "1b1918",
    "f22c40",
    "df5320",
    "c38418",
    "7b9726",
    "3d97b8",
    "407ee7",
    "6666ea",
    "c33ff3"
  ],
  "Atelier Forest": [
    "1b1918",
    "2c2421",
    "68615e",
    "766e6b",
    "9c9491",
    "a8a19f",
    "e6e2e0",
    "f1efee",
    "f22c40",
    "df5320",
    "c38418",
    "7b9726",
    "3d97b8",
    "407ee7",
    "6666ea",
    "c33ff3"
  ],
  "Atelier Heath Light": [
    "f7f3f7",
    "d8cad8",
    "ab9bab",
    "9e8f9e",
    "776977",
    "695d69",
    "292329",
    "1b181b",
    "ca402b",
    "a65926",
    "bb8a35",
    "918b3b",
    "159393",
    "516aec",
    "7b59c0",
    "cc33cc"
  ],
  "Atelier Heath": [
    "1b181b",
    "292329",
    "695d69",
    "776977",
    "9e8f9e",
    "ab9bab",
    "d8cad8",
    "f7f3f7",
    "ca402b",
    "a65926",
    "bb8a35",
    "918b3b",
    "159393",
    "516aec",
    "7b59c0",
    "cc33cc"
  ],
  "Atelier Lakeside Light": [
    "ebf8ff",
    "c1e4f6",
    "7ea2b4",
    "7195a8",
    "5a7b8c",
    "516d7b",
    "1f292e",
    "161b1d",
    "d22d72",
    "935c25",
    "8a8a0f",
    "568c3b",
    "2d8f6f",
    "257fad",
    "6b6bb8",
    "b72dd2"
  ],
  "Atelier Lakeside": [
    "161b1d",
    "1f292e",
    "516d7b",
    "5a7b8c",
    "7195a8",
    "7ea2b4",
    "c1e4f6",
    "ebf8ff",
    "d22d72",
    "935c25",
    "8a8a0f",
    "568c3b",
    "2d8f6f",
    "257fad",
    "6b6bb8",
    "b72dd2"
  ],
  "Atelier Plateau Light": [
    "f4ecec",
    "e7dfdf",
    "8a8585",
    "7e7777",
    "655d5d",
    "585050",
    "292424",
    "1b1818",
    "ca4949",
    "b45a3c",
    "a06e3b",
    "4b8b8b",
    "5485b6",
    "7272ca",
    "8464c4",
    "bd5187"
  ],
  "Atelier Plateau": [
    "1b1818",
    "292424",
    "585050",
    "655d5d",
    "7e7777",
    "8a8585",
    "e7dfdf",
    "f4ecec",
    "ca4949",
    "b45a3c",
    "a06e3b",
    "4b8b8b",
    "5485b6",
    "7272ca",
    "8464c4",
    "bd5187"
  ],
  "Atelier Savanna Light": [
    "ecf4ee",
    "dfe7e2",
    "87928a",
    "78877d",
    "5f6d64",
    "526057",
    "232a25",
    "171c19",
    "b16139",
    "9f713c",
    "a07e3b",
    "489963",
    "1c9aa0",
    "478c90",
    "55859b",
    "867469"
  ],
  "Atelier Savanna": [
    "171c19",
    "232a25",
    "526057",
    "5f6d64",
    "78877d",
    "87928a",
    "dfe7e2",
    "ecf4ee",
    "b16139",
    "9f713c",
    "a07e3b",
    "489963",
    "1c9aa0",
    "478c90",
    "55859b",
    "867469"
  ],
  "Atelier Seaside Light": [
    "f4fbf4",
    "cfe8cf",
    "8ca68c",
    "809980",
    "687d68",
    "5e6e5e",
    "242924",
    "131513",
    "e6193c",
    "87711d",
    "98981b",
    "29a329",
    "1999b3",
    "3d62f5",
    "ad2bee",
    "e619c3"
  ],
  "Atelier Seaside": [
    "131513",
    "242924",
    "5e6e5e",
    "687d68",
    "809980",
    "8ca68c",
    "cfe8cf",
    "f4fbf4",
    "e6193c",
    "87711d",
    "98981b",
    "29a329",
    "1999b3",
    "3d62f5",
    "ad2bee",
    "e619c3"
  ],
  "Atelier Sulphurpool Light": [
    "f5f7ff",
    "dfe2f1",
    "979db4",
    "898ea4",
    "6b7394",
    "5e6687",
    "293256",
    "202746",
    "c94922",
    "c76b29",
    "c08b30",
    "ac9739",
    "22a2c9",
    "3d8fd1",
    "6679cc",
    "9c637a"
  ],
  "Atelier Sulphurpool": [
    "202746",
    "293256",
    "5e6687",
    "6b7394",
    "898ea4",
    "979db4",
    "dfe2f1",
    "f5f7ff",
    "c94922",
    "c76b29",
    "c08b30",
    "ac9739",
    "22a2c9",
    "3d8fd1",
    "6679cc",
    "9c637a"
  ],
  "Atlas": [
    "002635",
    "00384d",
    "517F8D",
    "6C8B91",
    "869696",
    "a1a19a",
    "e6e6dc",
    "fafaf8",
    "ff5a67",
    "f08e48",
    "ffcc1b",
    "7fc06e",
    "5dd7b9",
    "14747e",
    "9a70a4",
    "c43060"
  ],
  "Black Metal (Bathory)": [
    "000000",
    "121212",
    "222222",
    "333333",
    "999999",
    "c1c1c1",
    "999999",
    "c1c1c1",
    "5f8787",
    "aaaaaa",
    "e78a53",
    "fbcb97",
    "aaaaaa",
    "888888",
    "999999",
    "444444"
  ],
  "Black Metal (Burzum)": [
    "000000",
    "121212",
    "222222",
    "333333",
    "999999",
    "c1c1c1",
    "999999",
    "c1c1c1",
    "5f8787",
    "aaaaaa",
    "99bbaa",
    "ddeecc",
    "aaaaaa",
    "888888",
    "999999",
    "444444"
  ],
  "Black Metal (Dark Funeral)": [
    "000000",
    "121212",
    "222222",
    "333333",
    "999999",
    "c1c1c1",
    "999999",
    "c1c1c1",
    "5f8787",
    "aaaaaa",
    "5f81a5",
    "d0dfee",
    "aaaaaa",
    "888888",
    "999999",
    "444444"
  ],
  "Black Metal (Gorgoroth)": [
    "000000",
    "121212",
    "222222",
    "333333",
    "999999",
    "c1c1c1",
    "999999",
    "c1c1c1",
    "5f8787",
    "aaaaaa",
    "8c7f70",
    "9b8d7f",
    "aaaaaa",
    "888888",
    "999999",
    "444444"
  ],
  "Black Metal (Immortal)": [
    "000000",
    "121212",
    "222222",
    "333333",
    "999999",
    "c1c1c1",
    "999999",
    "c1c1c1",
    "5f8787",
    "aaaaaa",
    "556677",
    "7799bb",
    "aaaaaa",
    "888888",
    "999999",
    "444444"
  ],
  "Black Metal (Khold)": [
    "000000",
    "121212",
    "222222",
    "333333",
    "999999",
    "c1c1c1",
    "999999",
    "c1c1c1",
    "5f8787",
    "aaaaaa",
    "974b46",
    "eceee3",
    "aaaaaa",
    "888888",
    "999999",
    "444444"
  ],
  "Black Metal (Marduk)": [
    "000000",
    "121212",
    "222222",
    "333333",
    "999999",
    "c1c1c1",
    "999999",
    "c1c1c1",
    "5f8787",
    "aaaaaa",
    "626b67",
    "a5aaa7",
    "aaaaaa",
    "888888",
    "999999",
    "444444"
  ],
  "Black Metal (Mayhem)": [
    "000000",
    "121212",
    "222222",
    "333333",
    "999999",
    "c1c1c1",
    "999999",
    "c1c1c1",
    "5f8787",
    "aaaaaa",
    "eecc6c",
    "f3ecd4",
    "aaaaaa",
    "888888",
    "999999",
    "444444"
  ],
  "Black Metal (Nile)": [
    "000000",
    "121212",
    "222222",
    "333333",
    "999999",
    "c1c1c1",
    "999999",
    "c1c1c1",
    "5f8787",
    "aaaaaa",
    "777755",
    "aa9988",
    "aaaaaa",
    "888888",
    "999999",
    "444444"
  ],
  "Black Metal (Venom)": [
    "000000",
    "121212",
    "222222",
    "333333",
    "999999",
    "c1c1c1",
    "999999",
    "c1c1c1",
    "5f8787",
    "aaaaaa",
    "79241f",
    "f8f7f2",
    "aaaaaa",
    "888888",
    "999999",
    "444444"
  ],
  "Black Metal": [
    "000000",
    "121212",
    "222222",
    "333333",
    "999999",
    "c1c1c1",
    "999999",
    "c1c1c1",
    "5f8787",
    "aaaaaa",
    "a06666",
    "dd9999",
    "aaaaaa",
    "888888",
    "999999",
    "444444"
  ],
  "Brogrammer": [
    "1f1f1f",
    "f81118",
    "2dc55e",
    "ecba0f",
    "2a84d2",
    "4e5ab7",
    "1081d6",
    "d6dbe5",
    "d6dbe5",
    "de352e",
    "1dd361",
    "f3bd09",
    "1081d6",
    "5350b9",
    "0f7ddb",
    "ffffff"
  ],
  "Brush Trees Dark": [
    "485867",
    "5A6D7A",
    "6D828E",
    "8299A1",
    "98AFB5",
    "B0C5C8",
    "C9DBDC",
    "E3EFEF",
    "b38686",
    "d8bba2",
    "aab386",
    "87b386",
    "86b3b3",
    "868cb3",
    "b386b2",
    "b39f9f"
  ],
  "Brush Trees": [
    "E3EFEF",
    "C9DBDC",
    "B0C5C8",
    "98AFB5",
    "8299A1",
    "6D828E",
    "5A6D7A",
    "485867",
    "b38686",
    "d8bba2",
    "aab386",
    "87b386",
    "86b3b3",
    "868cb3",
    "b386b2",
    "b39f9f"
  ],
  "Circus": [
    "191919",
    "202020",
    "303030",
    "5f5a60",
    "505050",
    "a7a7a7",
    "808080",
    "ffffff",
    "dc657d",
    "4bb1a7",
    "c3ba63",
    "84b97c",
    "4bb1a7",
    "639ee4",
    "b888e2",
    "b888e2"
  ],
  "Classic Dark": [
    "151515",
    "202020",
    "303030",
    "505050",
    "B0B0B0",
    "D0D0D0",
    "E0E0E0",
    "F5F5F5",
    "AC4142",
    "D28445",
    "F4BF75",
    "90A959",
    "75B5AA",
    "6A9FB5",
    "AA759F",
    "8F5536"
  ],
  "Classic Light": [
    "F5F5F5",
    "E0E0E0",
    "D0D0D0",
    "B0B0B0",
    "505050",
    "303030",
    "202020",
    "151515",
    "AC4142",
    "D28445",
    "F4BF75",
    "90A959",
    "75B5AA",
    "6A9FB5",
    "AA759F",
    "8F5536"
  ],
  "Codeschool": [
    "232c31",
    "1c3657",
    "2a343a",
    "3f4944",
    "84898c",
    "9ea7a6",
    "a7cfa3",
    "b5d8f6",
    "2a5491",
    "43820d",
    "a03b1e",
    "237986",
    "b02f30",
    "484d79",
    "c59820",
    "c98344"
  ],
  "Colors": [
    "111111",
    "333333",
    "555555",
    "777777",
    "999999",
    "bbbbbb",
    "dddddd",
    "ffffff",
    "ff4136",
    "ff851b",
    "ffdc00",
    "2ecc40",
    "7fdbff",
    "0074d9",
    "b10dc9",
    "85144b"
  ],
  "Cupertino": [
    "ffffff",
    "c0c0c0",
    "c0c0c0",
    "808080",
    "808080",
    "404040",
    "404040",
    "5e5e5e",
    "c41a15",
    "eb8500",
    "826b28",
    "007400",
    "318495",
    "0000ff",
    "a90d91",
    "826b28"
  ],
  "DanQing": [
    "2d302f",
    "434846",
    "5a605d",
    "9da8a3",
    "cad8d2",
    "e0f0eF",
    "ecf6f2",
    "fcfefd",
    "F9906F",
    "B38A61",
    "F0C239",
    "8AB361",
    "30DFF3",
    "B0A4E3",
    "CCA4E3",
    "CA6924"
  ],
  "Darcula": [
    "2b2b2b",
    "323232",
    "323232",
    "606366",
    "a4a3a3",
    "a9b7c6",
    "ffc66d",
    "ffffff",
    "4eade5",
    "689757",
    "bbb529",
    "6a8759",
    "629755",
    "9876aa",
    "cc7832",
    "808080"
  ],
  "darkmoss": [
    "171e1f",
    "252c2d",
    "373c3d",
    "555e5f",
    "818f80",
    "c7c7a5",
    "e3e3c8",
    "e1eaef",
    "ff4658",
    "e6db74",
    "fdb11f",
    "499180",
    "66d9ef",
    "498091",
    "9bc0c8",
    "d27b53"
  ],
  "Dark Violet": [
    "000000",
    "231a40",
    "432d59",
    "593380",
    "00ff00",
    "b08ae6",
    "9045e6",
    "a366ff",
    "a82ee6",
    "bb66cc",
    "f29df2",
    "4595e6",
    "40dfff",
    "4136d9",
    "7e5ce6",
    "a886bf"
  ],
  "Cupcake": [
    "fbf1f2",
    "f2f1f4",
    "d8d5dd",
    "bfb9c6",
    "a59daf",
    "8b8198",
    "72677E",
    "585062",
    "D57E85",
    "EBB790",
    "DCB16C",
    "A3B367",
    "69A9A7",
    "7297B9",
    "BB99B4",
    "BAA58C"
  ],
  "Default Dark": [
    "181818",
    "282828",
    "383838",
    "585858",
    "b8b8b8",
    "d8d8d8",
    "e8e8e8",
    "f8f8f8",
    "ab4642",
    "dc9656",
    "f7ca88",
    "a1b56c",
    "86c1b9",
    "7cafc2",
    "ba8baf",
    "a16946"
  ],
  "Default Light": [
    "f8f8f8",
    "e8e8e8",
    "d8d8d8",
    "b8b8b8",
    "585858",
    "383838",
    "282828",
    "181818",
    "ab4642",
    "dc9656",
    "f7ca88",
    "a1b56c",
    "86c1b9",
    "7cafc2",
    "ba8baf",
    "a16946"
  ],
  "Eighties": [
    "2d2d2d",
    "393939",
    "515151",
    "747369",
    "a09f93",
    "d3d0c8",
    "e8e6df",
    "f2f0ec",
    "f2777a",
    "f99157",
    "ffcc66",
    "99cc99",
    "66cccc",
    "6699cc",
    "cc99cc",
    "d27b53"
  ],
  "Mocha": [
    "3B3228",
    "534636",
    "645240",
    "7e705a",
    "b8afad",
    "d0c8c6",
    "e9e1dd",
    "f5eeeb",
    "cb6077",
    "d28b71",
    "f4bc87",
    "beb55b",
    "7bbda4",
    "8ab3b5",
    "a89bb9",
    "bb9584"
  ],
  "Ocean": [
    "2b303b",
    "343d46",
    "4f5b66",
    "65737e",
    "a7adba",
    "c0c5ce",
    "dfe1e8",
    "eff1f5",
    "bf616a",
    "d08770",
    "ebcb8b",
    "a3be8c",
    "96b5b4",
    "8fa1b3",
    "b48ead",
    "ab7967"
  ],
  "dirtysea": [
    "e0e0e0",
    "d0dad0",
    "d0d0d0",
    "707070",
    "202020",
    "000000",
    "f8f8f8",
    "c4d9c4",
    "840000",
    "006565",
    "755B00",
    "730073",
    "755B00",
    "007300",
    "000090",
    "755B00"
  ],
  "Dracula": [
    "282936",
    "3a3c4e",
    "4d4f68",
    "626483",
    "62d6e8",
    "e9e9f4",
    "f1f2f8",
    "f7f7fb",
    "ea51b2",
    "b45bcf",
    "00f769",
    "ebff87",
    "a1efe4",
    "62d6e8",
    "b45bcf",
    "00f769"
  ],
  "Edge Dark": [
    "262729",
    "88909f",
    "b7bec9",
    "3e4249",
    "73b3e7",
    "b7bec9",
    "d390e7",
    "3e4249",
    "e77171",
    "e77171",
    "dbb774",
    "a1bf78",
    "5ebaa5",
    "73b3e7",
    "d390e7",
    "5ebaa5"
  ],
  "Edge Light": [
    "fafafa",
    "7c9f4b",
    "d69822",
    "5e646f",
    "6587bf",
    "5e646f",
    "b870ce",
    "5e646f",
    "db7070",
    "db7070",
    "d69822",
    "7c9f4b",
    "509c93",
    "6587bf",
    "b870ce",
    "509c93"
  ],
  "Equilibrium Dark": [
    "0c1118",
    "181c22",
    "22262d",
    "7b776e",
    "949088",
    "afaba2",
    "cac6bd",
    "e7e2d9",
    "f04339",
    "df5923",
    "bb8801",
    "7f8b00",
    "00948b",
    "008dd1",
    "6a7fd2",
    "e3488e"
  ],
  "Equilibrium Gray Dark": [
    "111111",
    "1b1b1b",
    "262626",
    "777777",
    "919191",
    "ababab",
    "c6c6c6",
    "e2e2e2",
    "f04339",
    "df5923",
    "bb8801",
    "7f8b00",
    "00948b",
    "008dd1",
    "6a7fd2",
    "e3488e"
  ],
  "Equilibrium Gray Light": [
    "f1f1f1",
    "e2e2e2",
    "d4d4d4",
    "777777",
    "5e5e5e",
    "474747",
    "303030",
    "1b1b1b",
    "d02023",
    "bf3e05",
    "9d6f00",
    "637200",
    "007a72",
    "0073b5",
    "4e66b6",
    "c42775"
  ],
  "Equilibrium Light": [
    "f5f0e7",
    "e7e2d9",
    "d8d4cb",
    "73777f",
    "5a5f66",
    "43474e",
    "2c3138",
    "181c22",
    "d02023",
    "bf3e05",
    "9d6f00",
    "637200",
    "007a72",
    "0073b5",
    "4e66b6",
    "c42775"
  ],
  "Decaf": [
    "2d2d2d",
    "393939",
    "515151",
    "777777",
    "b4b7b4",
    "cccccc",
    "e0e0e0",
    "ffffff",
    "ff7f7b",
    "ffbf70",
    "ffd67c",
    "beda78",
    "bed6ff",
    "90bee1",
    "efb3f7",
    "ff93b3"
  ],
  "Espresso": [
    "2d2d2d",
    "393939",
    "515151",
    "777777",
    "b4b7b4",
    "cccccc",
    "e0e0e0",
    "ffffff",
    "d25252",
    "f9a959",
    "ffc66d",
    "a5c261",
    "bed6ff",
    "6c99bb",
    "d197d9",
    "f97394"
  ],
  "Eva Dim": [
    "2a3b4d",
    "3d566f",
    "4b6988",
    "55799c",
    "7e90a3",
    "9fa2a6",
    "d6d7d9",
    "ffffff",
    "c4676c",
    "ff9966",
    "cfd05d",
    "5de561",
    "4b8f77",
    "1ae1dc",
    "9c6cd3",
    "bb64a9"
  ],
  "Eva": [
    "2a3b4d",
    "3d566f",
    "4b6988",
    "55799c",
    "7e90a3",
    "9fa2a6",
    "d6d7d9",
    "ffffff",
    "c4676c",
    "ff9966",
    "ffff66",
    "66ff66",
    "4b8f77",
    "15f4ee",
    "9c6cd3",
    "bb64a9"
  ],
  "Framer": [
    "181818",
    "151515",
    "464646",
    "747474",
    "B9B9B9",
    "D0D0D0",
    "E8E8E8",
    "EEEEEE",
    "FD886B",
    "FC4769",
    "FECB6E",
    "32CCDC",
    "ACDDFD",
    "20BCFC",
    "BA8CFC",
    "B15F4A"
  ],
  "Fruit Soda": [
    "f1ecf1",
    "e0dee0",
    "d8d5d5",
    "b5b4b6",
    "979598",
    "515151",
    "474545",
    "2d2c2c",
    "fe3e31",
    "fe6d08",
    "f7e203",
    "47f74c",
    "0f9cfd",
    "2931df",
    "611fce",
    "b16f40"
  ],
  "Gigavolt": [
    "202126",
    "2d303d",
    "5a576e",
    "a1d2e6",
    "cad3ff",
    "e9e7e1",
    "eff0f9",
    "f2fbff",
    "ff661a",
    "19f988",
    "ffdc2d",
    "f2e6a9",
    "fb6acb",
    "40bfff",
    "ae94f9",
    "6187ff"
  ],
  "Github": [
    "ffffff",
    "f5f5f5",
    "c8c8fa",
    "969896",
    "e8e8e8",
    "333333",
    "ffffff",
    "ffffff",
    "ed6a43",
    "0086b3",
    "795da3",
    "183691",
    "183691",
    "795da3",
    "a71d5d",
    "333333"
  ],
  "Gruvbox dark, hard": [
    "1d2021",
    "3c3836",
    "504945",
    "665c54",
    "bdae93",
    "d5c4a1",
    "ebdbb2",
    "fbf1c7",
    "fb4934",
    "fe8019",
    "fabd2f",
    "b8bb26",
    "8ec07c",
    "83a598",
    "d3869b",
    "d65d0e"
  ],
  "Gruvbox dark, medium": [
    "282828",
    "3c3836",
    "504945",
    "665c54",
    "bdae93",
    "d5c4a1",
    "ebdbb2",
    "fbf1c7",
    "fb4934",
    "fe8019",
    "fabd2f",
    "b8bb26",
    "8ec07c",
    "83a598",
    "d3869b",
    "d65d0e"
  ],
  "Gruvbox dark, pale": [
    "262626",
    "3a3a3a",
    "4e4e4e",
    "8a8a8a",
    "949494",
    "dab997",
    "d5c4a1",
    "ebdbb2",
    "d75f5f",
    "ff8700",
    "ffaf00",
    "afaf00",
    "85ad85",
    "83adad",
    "d485ad",
    "d65d0e"
  ],
  "Gruvbox dark, soft": [
    "32302f",
    "3c3836",
    "504945",
    "665c54",
    "bdae93",
    "d5c4a1",
    "ebdbb2",
    "fbf1c7",
    "fb4934",
    "fe8019",
    "fabd2f",
    "b8bb26",
    "8ec07c",
    "83a598",
    "d3869b",
    "d65d0e"
  ],
  "Gruvbox light, hard": [
    "f9f5d7",
    "ebdbb2",
    "d5c4a1",
    "bdae93",
    "665c54",
    "504945",
    "3c3836",
    "282828",
    "9d0006",
    "af3a03",
    "b57614",
    "79740e",
    "427b58",
    "076678",
    "8f3f71",
    "d65d0e"
  ],
  "Gruvbox light, medium": [
    "fbf1c7",
    "ebdbb2",
    "d5c4a1",
    "bdae93",
    "665c54",
    "504945",
    "3c3836",
    "282828",
    "9d0006",
    "af3a03",
    "b57614",
    "79740e",
    "427b58",
    "076678",
    "8f3f71",
    "d65d0e"
  ],
  "Gruvbox light, soft": [
    "f2e5bc",
    "ebdbb2",
    "d5c4a1",
    "bdae93",
    "665c54",
    "504945",
    "3c3836",
    "282828",
    "9d0006",
    "af3a03",
    "b57614",
    "79740e",
    "427b58",
    "076678",
    "8f3f71",
    "d65d0e"
  ],
  "Hardcore": [
    "212121",
    "303030",
    "353535",
    "4A4A4A",
    "707070",
    "cdcdcd",
    "e5e5e5",
    "ffffff",
    "f92672",
    "fd971f",
    "e6db74",
    "a6e22e",
    "708387",
    "66d9ef",
    "9e6ffe",
    "e8b882"
  ],
  "Heetch Light": [
    "feffff",
    "392551",
    "7b6d8b",
    "9c92a8",
    "ddd6e5",
    "5a496e",
    "470546",
    "190134",
    "27d9d5",
    "bdb6c5",
    "5ba2b6",
    "f80059",
    "c33678",
    "47f9f5",
    "bd0152",
    "dedae2"
  ],
  "Heetch Dark": [
    "190134",
    "392551",
    "5A496E",
    "7B6D8B",
    "9C92A8",
    "BDB6C5",
    "DEDAE2",
    "FEFFFF",
    "27D9D5",
    "5BA2B6",
    "8F6C97",
    "C33678",
    "F80059",
    "BD0152",
    "82034C",
    "470546"
  ],
  "Helios": [
    "1d2021",
    "383c3e",
    "53585b",
    "6f7579",
    "cdcdcd",
    "d5d5d5",
    "dddddd",
    "e5e5e5",
    "d72638",
    "eb8413",
    "f19d1a",
    "88b92d",
    "1ba595",
    "1e8bac",
    "be4264",
    "c85e0d"
  ],
  "Horizon Dark": [
    "1C1E26",
    "232530",
    "2E303E",
    "6F6F70",
    "9DA0A2",
    "CBCED0",
    "DCDFE4",
    "E3E6EE",
    "E95678",
    "FAB795",
    "FAC29A",
    "29D398",
    "59E1E3",
    "26BBD9",
    "EE64AC",
    "F09383"
  ],
  "Horizon Light": [
    "FDF0ED",
    "FADAD1",
    "F9CBBE",
    "BDB3B1",
    "948C8A",
    "403C3D",
    "302C2D",
    "201C1D",
    "E95678",
    "F9CEC3",
    "FADAD1",
    "29D398",
    "59E1E3",
    "26BBD9",
    "EE64AC",
    "F9CBBE"
  ],
  "Humanoid dark": [
    "232629",
    "333b3d",
    "484e54",
    "60615d",
    "c0c0bd",
    "f8f8f2",
    "fcfcf6",
    "fcfcfc",
    "f11235",
    "ff9505",
    "ffb627",
    "02d849",
    "0dd9d6",
    "00a6fb",
    "f15ee3",
    "b27701"
  ],
  "Humanoid light": [
    "f8f8f2",
    "efefe9",
    "deded8",
    "c0c0bd",
    "60615d",
    "232629",
    "2f3337",
    "070708",
    "b0151a",
    "ff3d00",
    "ffb627",
    "388e3c",
    "008e8e",
    "0082c9",
    "700f98",
    "b27701"
  ],
  "iA Dark": [
    "1a1a1a",
    "222222",
    "1d414d",
    "767676",
    "b8b8b8",
    "cccccc",
    "e8e8e8",
    "f8f8f8",
    "d88568",
    "d86868",
    "b99353",
    "83a471",
    "7c9cae",
    "8eccdd",
    "b98eb2",
    "8b6c37"
  ],
  "iA Light": [
    "f6f6f6",
    "dedede",
    "bde5f2",
    "898989",
    "767676",
    "181818",
    "e8e8e8",
    "f8f8f8",
    "9c5a02",
    "c43e18",
    "c48218",
    "38781c",
    "2d6bb1",
    "48bac2",
    "a94598",
    "8b6c37"
  ],
  "Icy Dark": [
    "021012",
    "031619",
    "041f23",
    "052e34",
    "064048",
    "095b67",
    "0c7c8c",
    "109cb0",
    "16c1d9",
    "b3ebf2",
    "80deea",
    "4dd0e1",
    "26c6da",
    "00bcd4",
    "00acc1",
    "0097a7"
  ],
  "Kimber": [
    "222222",
    "313131",
    "555D55",
    "644646",
    "5A5A5A",
    "DEDEE7",
    "C3C3B4",
    "FFFFE6",
    "C88C8C",
    "476C88",
    "D8B56D",
    "99C899",
    "78B4B4",
    "537C9C",
    "86CACD",
    "704F4F"
  ],
  "Materia": [
    "263238",
    "2C393F",
    "37474F",
    "707880",
    "C9CCD3",
    "CDD3DE",
    "D5DBE5",
    "FFFFFF",
    "EC5F67",
    "EA9560",
    "FFCC00",
    "8BD649",
    "80CBC4",
    "89DDFF",
    "82AAFF",
    "EC5F67"
  ],
  "Material Vivid": [
    "202124",
    "27292c",
    "323639",
    "44464d",
    "676c71",
    "80868b",
    "9e9e9e",
    "ffffff",
    "f44336",
    "ff9800",
    "ffeb3b",
    "00e676",
    "00bcd4",
    "2196f3",
    "673ab7",
    "8d6e63"
  ],
  "Material Darker": [
    "212121",
    "303030",
    "353535",
    "4A4A4A",
    "B2CCD6",
    "EEFFFF",
    "EEFFFF",
    "FFFFFF",
    "F07178",
    "F78C6C",
    "FFCB6B",
    "C3E88D",
    "89DDFF",
    "82AAFF",
    "C792EA",
    "FF5370"
  ],
  "Material Lighter": [
    "FAFAFA",
    "E7EAEC",
    "CCEAE7",
    "CCD7DA",
    "8796B0",
    "80CBC4",
    "80CBC4",
    "FFFFFF",
    "FF5370",
    "F76D47",
    "FFB62C",
    "91B859",
    "39ADB5",
    "6182B8",
    "7C4DFF",
    "E53935"
  ],
  "Material Palenight": [
    "292D3E",
    "444267",
    "32374D",
    "676E95",
    "8796B0",
    "959DCB",
    "959DCB",
    "FFFFFF",
    "F07178",
    "F78C6C",
    "FFCB6B",
    "C3E88D",
    "89DDFF",
    "82AAFF",
    "C792EA",
    "FF5370"
  ],
  "Material": [
    "263238",
    "2E3C43",
    "314549",
    "546E7A",
    "B2CCD6",
    "EEFFFF",
    "EEFFFF",
    "FFFFFF",
    "F07178",
    "F78C6C",
    "FFCB6B",
    "C3E88D",
    "89DDFF",
    "82AAFF",
    "C792EA",
    "FF5370"
  ],
  "Mellow Purple": [
    "1e0528",
    "1A092D",
    "331354",
    "320f55",
    "873582",
    "ffeeff",
    "ffeeff",
    "f8c0ff",
    "00d9e9",
    "aa00a3",
    "955ae7",
    "05cb0d",
    "b900b1",
    "550068",
    "8991bb",
    "4d6fff"
  ],
  "Mexico Light": [
    "f8f8f8",
    "e8e8e8",
    "d8d8d8",
    "b8b8b8",
    "585858",
    "383838",
    "282828",
    "181818",
    "ab4642",
    "dc9656",
    "f79a0e",
    "538947",
    "4b8093",
    "7cafc2",
    "96609e",
    "a16946"
  ],
  "Nebula": [
    "22273b",
    "414f60",
    "5a8380",
    "6e6f72",
    "87888b",
    "a4a6a9",
    "c7c9cd",
    "8dbdaa",
    "777abc",
    "94929e",
    "4f9062",
    "6562a8",
    "226f68",
    "4d6bb6",
    "716cae",
    "8c70a7"
  ],
  "Nord": [
    "2E3440",
    "3B4252",
    "434C5E",
    "4C566A",
    "D8DEE9",
    "E5E9F0",
    "ECEFF4",
    "8FBCBB",
    "BF616A",
    "D08770",
    "EBCB8B",
    "A3BE8C",
    "88C0D0",
    "81A1C1",
    "B48EAD",
    "5E81AC"
  ],
  "Nova": [
    "3C4C55",
    "556873",
    "6A7D89",
    "899BA6",
    "899BA6",
    "C5D4DD",
    "899BA6",
    "556873",
    "83AFE5",
    "7FC1CA",
    "A8CE93",
    "7FC1CA",
    "F2C38F",
    "83AFE5",
    "9A93E1",
    "F2C38F"
  ],
  "One Light": [
    "fafafa",
    "f0f0f1",
    "e5e5e6",
    "a0a1a7",
    "696c77",
    "383a42",
    "202227",
    "090a0b",
    "ca1243",
    "d75f00",
    "c18401",
    "50a14f",
    "0184bc",
    "4078f2",
    "a626a4",
    "986801"
  ],
  "OneDark": [
    "282c34",
    "353b45",
    "3e4451",
    "545862",
    "565c64",
    "abb2bf",
    "b6bdca",
    "c8ccd4",
    "e06c75",
    "d19a66",
    "e5c07b",
    "98c379",
    "56b6c2",
    "61afef",
    "c678dd",
    "be5046"
  ],
  "Outrun Dark": [
    "00002A",
    "20204A",
    "30305A",
    "50507A",
    "B0B0DA",
    "D0D0FA",
    "E0E0FF",
    "F5F5FF",
    "FF4242",
    "FC8D28",
    "F3E877",
    "59F176",
    "0EF0F0",
    "66B0FF",
    "F10596",
    "F003EF"
  ],
  "PaperColor Dark": [
    "1c1c1c",
    "af005f",
    "5faf00",
    "d7af5f",
    "5fafd7",
    "808080",
    "d7875f",
    "d0d0d0",
    "585858",
    "5faf5f",
    "afd700",
    "af87d7",
    "ffaf00",
    "ff5faf",
    "00afaf",
    "5f8787"
  ],
  "PaperColor Light": [
    "eeeeee",
    "af0000",
    "008700",
    "5f8700",
    "0087af",
    "444444",
    "005f87",
    "878787",
    "bcbcbc",
    "d70000",
    "d70087",
    "8700af",
    "d75f00",
    "d75f00",
    "005faf",
    "005f87"
  ],
  "Pasque": [
    "271C3A",
    "100323",
    "3E2D5C",
    "5D5766",
    "BEBCBF",
    "DEDCDF",
    "EDEAEF",
    "BBAADD",
    "A92258",
    "918889",
    "804ead",
    "C6914B",
    "7263AA",
    "8E7DC6",
    "953B9D",
    "59325C"
  ],
  "pinky": [
    "171517",
    "1b181b",
    "1d1b1d",
    "383338",
    "e7dbdb",
    "f5f5f5",
    "ffffff",
    "f7f3f7",
    "ffa600",
    "00ff66",
    "20df6c",
    "ff0066",
    "6600ff",
    "00ffff",
    "007fff",
    "df206c"
  ],
  "Porple": [
    "292c36",
    "333344",
    "474160",
    "65568a",
    "b8b8b8",
    "d8d8d8",
    "e8e8e8",
    "f8f8f8",
    "f84547",
    "d28e5d",
    "efa16b",
    "95c76f",
    "64878f",
    "8485ce",
    "b74989",
    "986841"
  ],
  "Purpledream": [
    "100510",
    "302030",
    "403040",
    "605060",
    "bbb0bb",
    "ddd0dd",
    "eee0ee",
    "fff0ff",
    "FF1D0D",
    "CCAE14",
    "F000A0",
    "14CC64",
    "0075B0",
    "00A0F0",
    "B000D0",
    "6A2A3C"
  ],
  "Qualia": [
    "101010",
    "454545",
    "454545",
    "454545",
    "808080",
    "C0C0C0",
    "C0C0C0",
    "454545",
    "EFA6A2",
    "A3B8EF",
    "E6A3DC",
    "80C990",
    "C8C874",
    "50CACD",
    "E0AF85",
    "808080"
  ],
  "Rebecca": [
    "292a44",
    "663399",
    "383a62",
    "666699",
    "a0a0c5",
    "f1eff8",
    "ccccff",
    "53495d",
    "a0a0c5",
    "efe4a1",
    "ae81ff",
    "6dfedf",
    "8eaee0",
    "2de0a7",
    "7aa5ff",
    "ff79c6"
  ],
  "Rosé Pine Dawn": [
    "faf4ed",
    "fffaf3",
    "f2e9de",
    "9893a5",
    "6e6a86",
    "575279",
    "555169",
    "26233a",
    "1f1d2e",
    "b4637a",
    "ea9d34",
    "d7827e",
    "286983",
    "56949f",
    "907aa9",
    "c5c3ce"
  ],
  "Rosé Pine Moon": [
    "232136",
    "2a273f",
    "393552",
    "59546d",
    "817c9c",
    "e0def4",
    "f5f5f7",
    "d9d7e1",
    "ecebf0",
    "eb6f92",
    "f6c177",
    "ea9a97",
    "3e8fb0",
    "9ccfd8",
    "c4a7e7",
    "b9b9bc"
  ],
  "Rosé Pine": [
    "191724",
    "1f1d2e",
    "26233a",
    "555169",
    "6e6a86",
    "e0def4",
    "f0f0f3",
    "c5c3ce",
    "e2e1e7",
    "eb6f92",
    "f6c177",
    "ebbcba",
    "31748f",
    "9ccfd8",
    "c4a7e7",
    "e5e5e5"
  ],
  "Sagelight": [
    "f8f8f8",
    "e8e8e8",
    "d8d8d8",
    "b8b8b8",
    "585858",
    "383838",
    "282828",
    "181818",
    "fa8480",
    "ffaa61",
    "ffdc61",
    "a0d2c8",
    "a2d6f5",
    "a0a7d2",
    "c8a0d2",
    "d2b2a0"
  ],
  "Sakura": [
    "feedf3",
    "f8e2e7",
    "e0ccd1",
    "755f64",
    "665055",
    "564448",
    "42383a",
    "33292b",
    "df2d52",
    "f6661e",
    "c29461",
    "2e916d",
    "1d8991",
    "006e93",
    "5e2180",
    "ba0d35"
  ],
  "Sandcastle": [
    "282c34",
    "2c323b",
    "3e4451",
    "665c54",
    "928374",
    "a89984",
    "d5c4a1",
    "fdf4c1",
    "83a598",
    "a07e3b",
    "a07e3b",
    "528b8b",
    "83a598",
    "83a598",
    "d75f5f",
    "a87322"
  ],
  "Shades of Purple": [
    "1e1e3f",
    "43d426",
    "f1d000",
    "808080",
    "6871ff",
    "c7c7c7",
    "ff77ff",
    "ffffff",
    "d90429",
    "f92a1c",
    "ffe700",
    "3ad900",
    "00c5c7",
    "6943ff",
    "ff2c70",
    "79e8fb"
  ],
  "Silk Dark": [
    "0e3c46",
    "1D494E",
    "2A5054",
    "587073",
    "9DC8CD",
    "C7DBDD",
    "CBF2F7",
    "D2FAFF",
    "fb6953",
    "fcab74",
    "fce380",
    "73d8ad",
    "3fb2b9",
    "46bddd",
    "756b8a",
    "9b647b"
  ],
  "Silk Light": [
    "E9F1EF",
    "CCD4D3",
    "90B7B6",
    "5C787B",
    "4B5B5F",
    "385156",
    "0e3c46",
    "D2FAFF",
    "CF432E",
    "D27F46",
    "CFAD25",
    "6CA38C",
    "329CA2",
    "39AAC9",
    "6E6582",
    "865369"
  ],
  "Snazzy": [
    "282a36",
    "34353e",
    "43454f",
    "78787e",
    "a5a5a9",
    "e2e4e5",
    "eff0eb",
    "f1f1f0",
    "ff5c57",
    "ff9f43",
    "f3f99d",
    "5af78e",
    "9aedfe",
    "57c7ff",
    "ff6ac1",
    "b2643c"
  ],
  "Solar Flare Light": [
    "F5F7FA",
    "E8E9ED",
    "A6AFB8",
    "85939E",
    "667581",
    "586875",
    "222E38",
    "18262F",
    "EF5253",
    "E66B2B",
    "E4B51C",
    "7CC844",
    "52CBB0",
    "33B5E1",
    "A363D5",
    "D73C9A"
  ],
  "Solar Flare": [
    "18262F",
    "222E38",
    "586875",
    "667581",
    "85939E",
    "A6AFB8",
    "E8E9ED",
    "F5F7FA",
    "EF5253",
    "E66B2B",
    "E4B51C",
    "7CC844",
    "52CBB0",
    "33B5E1",
    "A363D5",
    "D73C9A"
  ],
  "Solarized Dark": [
    "002b36",
    "073642",
    "586e75",
    "657b83",
    "839496",
    "93a1a1",
    "eee8d5",
    "fdf6e3",
    "dc322f",
    "cb4b16",
    "b58900",
    "859900",
    "2aa198",
    "268bd2",
    "6c71c4",
    "d33682"
  ],
  "Solarized Light": [
    "fdf6e3",
    "eee8d5",
    "93a1a1",
    "839496",
    "657b83",
    "586e75",
    "073642",
    "002b36",
    "dc322f",
    "cb4b16",
    "b58900",
    "859900",
    "2aa198",
    "268bd2",
    "6c71c4",
    "d33682"
  ],
  "summercamp": [
    "1c1810",
    "2a261c",
    "3a3527",
    "504b38",
    "5f5b45",
    "736e55",
    "bab696",
    "f8f5de",
    "e35142",
    "fba11b",
    "f2ff27",
    "5ceb5a",
    "5aebbc",
    "489bf0",
    "FF8080",
    "F69BE7"
  ],
  "Summerfruit Dark": [
    "151515",
    "202020",
    "303030",
    "505050",
    "B0B0B0",
    "D0D0D0",
    "E0E0E0",
    "FFFFFF",
    "FF0086",
    "FD8900",
    "ABA800",
    "00C918",
    "1FAAAA",
    "3777E6",
    "AD00A1",
    "CC6633"
  ],
  "Summerfruit Light": [
    "FFFFFF",
    "E0E0E0",
    "D0D0D0",
    "B0B0B0",
    "000000",
    "101010",
    "151515",
    "202020",
    "FF0086",
    "FD8900",
    "ABA800",
    "00C918",
    "1FAAAA",
    "3777E6",
    "AD00A1",
    "CC6633"
  ],
  "Synth Midnight Terminal Dark": [
    "050608",
    "1a1b1c",
    "28292a",
    "474849",
    "a3a5a6",
    "c1c3c4",
    "cfd1d2",
    "dddfe0",
    "b53b50",
    "ea770d",
    "c9d364",
    "06ea61",
    "42fff9",
    "03aeff",
    "ea5ce2",
    "cd6320"
  ],
  "Synth Midnight Terminal Light": [
    "dddfe0",
    "cfd1d2",
    "c1c3c4",
    "a3a5a6",
    "474849",
    "28292a",
    "1a1b1c",
    "050608",
    "b53b50",
    "ea770d",
    "c9d364",
    "06ea61",
    "42fff9",
    "03aeff",
    "ea5ce2",
    "cd6320"
  ],
  "Tango": [
    "2e3436",
    "8ae234",
    "fce94f",
    "555753",
    "729fcf",
    "d3d7cf",
    "ad7fa8",
    "eeeeec",
    "cc0000",
    "ef2929",
    "c4a000",
    "4e9a06",
    "06989a",
    "3465a4",
    "75507b",
    "34e2e2"
  ],
  "tender": [
    "282828",
    "383838",
    "484848",
    "4c4c4c",
    "b8b8b8",
    "eeeeee",
    "e8e8e8",
    "feffff",
    "f43753",
    "dc9656",
    "ffc24b",
    "c9d05c",
    "73cef4",
    "b3deef",
    "d3b987",
    "a16946"
  ],
  "Tomorrow Night": [
    "1d1f21",
    "282a2e",
    "373b41",
    "969896",
    "b4b7b4",
    "c5c8c6",
    "e0e0e0",
    "ffffff",
    "cc6666",
    "de935f",
    "f0c674",
    "b5bd68",
    "8abeb7",
    "81a2be",
    "b294bb",
    "a3685a"
  ],
  "Tomorrow": [
    "ffffff",
    "e0e0e0",
    "d6d6d6",
    "8e908c",
    "969896",
    "4d4d4c",
    "282a2e",
    "1d1f21",
    "c82829",
    "f5871f",
    "eab700",
    "718c00",
    "3e999f",
    "4271ae",
    "8959a8",
    "a3685a"
  ],
  "Twilight": [
    "1e1e1e",
    "323537",
    "464b50",
    "5f5a60",
    "838184",
    "a7a7a7",
    "c3c3c3",
    "ffffff",
    "cf6a4c",
    "cda869",
    "f9ee98",
    "8f9d6a",
    "afc4db",
    "7587a6",
    "9b859d",
    "9b703f"
  ],
  "3024": [
    "090300",
    "3a3432",
    "4a4543",
    "5c5855",
    "807d7c",
    "a5a2a2",
    "d6d5d4",
    "f7f7f7",
    "db2d20",
    "e8bbd0",
    "fded02",
    "01a252",
    "b5e4f4",
    "01a0e4",
    "a16a94",
    "cdab53"
  ],
  "Apathy": [
    "031A16",
    "0B342D",
    "184E45",
    "2B685E",
    "5F9C92",
    "81B5AC",
    "A7CEC8",
    "D2E7E4",
    "3E9688",
    "3E7996",
    "3E4C96",
    "883E96",
    "963E4C",
    "96883E",
    "4C963E",
    "3E965B"
  ],
  "Ashes": [
    "1C2023",
    "393F45",
    "565E65",
    "747C84",
    "ADB3BA",
    "C7CCD1",
    "DFE2E5",
    "F3F4F5",
    "C7AE95",
    "C7C795",
    "AEC795",
    "95C7AE",
    "95AEC7",
    "AE95C7",
    "C795AE",
    "C79595"
  ],
  "Bespin": [
    "28211c",
    "36312e",
    "5e5d5c",
    "666666",
    "797977",
    "8a8986",
    "9d9b97",
    "baae9e",
    "cf6a4c",
    "cf7d34",
    "f9ee98",
    "54be0d",
    "afc4db",
    "5ea6ea",
    "9b859d",
    "937121"
  ],
  "Brewer": [
    "0c0d0e",
    "2e2f30",
    "515253",
    "737475",
    "959697",
    "b7b8b9",
    "dadbdc",
    "fcfdfe",
    "e31a1c",
    "e6550d",
    "dca060",
    "31a354",
    "80b1d3",
    "3182bd",
    "756bb1",
    "b15928"
  ],
  "Bright": [
    "000000",
    "303030",
    "505050",
    "b0b0b0",
    "d0d0d0",
    "e0e0e0",
    "f5f5f5",
    "ffffff",
    "fb0120",
    "fc6d24",
    "fda331",
    "a1c659",
    "76c7b7",
    "6fb3d2",
    "d381c3",
    "be643c"
  ],
  "Chalk": [
    "151515",
    "202020",
    "303030",
    "505050",
    "b0b0b0",
    "d0d0d0",
    "e0e0e0",
    "f5f5f5",
    "fb9fb1",
    "eda987",
    "ddb26f",
    "acc267",
    "12cfc0",
    "6fc2ef",
    "e1a3ee",
    "deaf8f"
  ],
  "Darktooth": [
    "1D2021",
    "32302F",
    "504945",
    "665C54",
    "928374",
    "A89984",
    "D5C4A1",
    "FDF4C1",
    "FB543F",
    "FE8625",
    "FAC03B",
    "95C085",
    "8BA59B",
    "0D6678",
    "8F4673",
    "A87322"
  ],
  "Embers": [
    "16130F",
    "2C2620",
    "433B32",
    "5A5047",
    "8A8075",
    "A39A90",
    "BEB6AE",
    "DBD6D1",
    "826D57",
    "828257",
    "6D8257",
    "57826D",
    "576D82",
    "6D5782",
    "82576D",
    "825757"
  ],
  "Flat": [
    "2C3E50",
    "34495E",
    "7F8C8D",
    "95A5A6",
    "BDC3C7",
    "e0e0e0",
    "f5f5f5",
    "ECF0F1",
    "E74C3C",
    "E67E22",
    "F1C40F",
    "2ECC71",
    "1ABC9C",
    "3498DB",
    "9B59B6",
    "be643c"
  ],
  "Google Dark": [
    "1d1f21",
    "282a2e",
    "373b41",
    "969896",
    "b4b7b4",
    "c5c8c6",
    "e0e0e0",
    "ffffff",
    "CC342B",
    "F96A38",
    "FBA922",
    "198844",
    "3971ED",
    "3971ED",
    "A36AC7",
    "3971ED"
  ],
  "Google Light": [
    "ffffff",
    "e0e0e0",
    "c5c8c6",
    "b4b7b4",
    "969896",
    "373b41",
    "282a2e",
    "1d1f21",
    "CC342B",
    "F96A38",
    "FBA922",
    "198844",
    "3971ED",
    "3971ED",
    "A36AC7",
    "3971ED"
  ],
  "Grayscale Dark": [
    "101010",
    "252525",
    "464646",
    "525252",
    "ababab",
    "b9b9b9",
    "e3e3e3",
    "f7f7f7",
    "7c7c7c",
    "999999",
    "a0a0a0",
    "8e8e8e",
    "868686",
    "686868",
    "747474",
    "5e5e5e"
  ],
  "Grayscale Light": [
    "f7f7f7",
    "e3e3e3",
    "b9b9b9",
    "ababab",
    "525252",
    "464646",
    "252525",
    "101010",
    "7c7c7c",
    "999999",
    "a0a0a0",
    "8e8e8e",
    "868686",
    "686868",
    "747474",
    "5e5e5e"
  ],
  "Green Screen": [
    "001100",
    "003300",
    "005500",
    "007700",
    "009900",
    "00bb00",
    "00dd00",
    "00ff00",
    "007700",
    "009900",
    "007700",
    "00bb00",
    "005500",
    "009900",
    "00bb00",
    "005500"
  ],
  "Harmonic16 Dark": [
    "0b1c2c",
    "223b54",
    "405c79",
    "627e99",
    "aabcce",
    "cbd6e2",
    "e5ebf1",
    "f7f9fb",
    "bf8b56",
    "bfbf56",
    "8bbf56",
    "56bf8b",
    "568bbf",
    "8b56bf",
    "bf568b",
    "bf5656"
  ],
  "Harmonic16 Light": [
    "f7f9fb",
    "e5ebf1",
    "cbd6e2",
    "aabcce",
    "627e99",
    "405c79",
    "223b54",
    "0b1c2c",
    "bf8b56",
    "bfbf56",
    "8bbf56",
    "56bf8b",
    "568bbf",
    "8b56bf",
    "bf568b",
    "bf5656"
  ],
  "Hopscotch": [
    "322931",
    "433b42",
    "5c545b",
    "797379",
    "989498",
    "b9b5b8",
    "d5d3d5",
    "ffffff",
    "dd464c",
    "fd8b19",
    "fdcc59",
    "8fc13e",
    "149b93",
    "1290bf",
    "c85e7c",
    "b33508"
  ],
  "IR Black": [
    "000000",
    "242422",
    "484844",
    "6c6c66",
    "918f88",
    "b5b3aa",
    "d9d7cc",
    "fdfbee",
    "ff6c60",
    "e9c062",
    "ffffb6",
    "a8ff60",
    "c6c5fe",
    "96cbfe",
    "ff73fd",
    "b18a3d"
  ],
  "Isotope": [
    "000000",
    "404040",
    "606060",
    "808080",
    "c0c0c0",
    "d0d0d0",
    "e0e0e0",
    "ffffff",
    "ff0000",
    "ff9900",
    "ff0099",
    "33ff00",
    "00ffff",
    "0066ff",
    "cc00ff",
    "3300ff"
  ],
  "Macintosh": [
    "000000",
    "404040",
    "404040",
    "808080",
    "808080",
    "c0c0c0",
    "c0c0c0",
    "ffffff",
    "dd0907",
    "ff6403",
    "fbf305",
    "1fb714",
    "02abea",
    "0000d3",
    "4700a5",
    "90713a"
  ],
  "Marrakesh": [
    "201602",
    "302e00",
    "5f5b17",
    "6c6823",
    "86813b",
    "948e48",
    "ccc37a",
    "faf0a5",
    "c35359",
    "b36144",
    "a88339",
    "18974e",
    "75a738",
    "477ca1",
    "8868b3",
    "b3588e"
  ],
  "Monokai": [
    "272822",
    "383830",
    "49483e",
    "75715e",
    "a59f85",
    "f8f8f2",
    "f5f4f1",
    "f9f8f5",
    "f92672",
    "fd971f",
    "f4bf75",
    "a6e22e",
    "a1efe4",
    "66d9ef",
    "ae81ff",
    "cc6633"
  ],
  "OceanicNext": [
    "1B2B34",
    "343D46",
    "4F5B66",
    "65737E",
    "A7ADBA",
    "C0C5CE",
    "CDD3DE",
    "D8DEE9",
    "EC5f67",
    "F99157",
    "FAC863",
    "99C794",
    "5FB3B3",
    "6699CC",
    "C594C5",
    "AB7967"
  ],
  "Paraiso": [
    "2f1e2e",
    "41323f",
    "4f424c",
    "776e71",
    "8d8687",
    "a39e9b",
    "b9b6b0",
    "e7e9db",
    "ef6155",
    "f99b15",
    "fec418",
    "48b685",
    "5bc4bf",
    "06b6ef",
    "815ba4",
    "e96ba8"
  ],
  "PhD": [
    "061229",
    "2a3448",
    "4d5666",
    "717885",
    "9a99a3",
    "b8bbc2",
    "dbdde0",
    "ffffff",
    "d07346",
    "f0a000",
    "fbd461",
    "99bf52",
    "72b9bf",
    "5299bf",
    "9989cc",
    "b08060"
  ],
  "Pico": [
    "000000",
    "1d2b53",
    "7e2553",
    "008751",
    "ab5236",
    "5f574f",
    "c2c3c7",
    "fff1e8",
    "ff004d",
    "ffa300",
    "fff024",
    "00e756",
    "29adff",
    "83769c",
    "ff77a8",
    "ffccaa"
  ],
  "Pop": [
    "000000",
    "202020",
    "303030",
    "505050",
    "b0b0b0",
    "d0d0d0",
    "e0e0e0",
    "ffffff",
    "eb008a",
    "f29333",
    "f8ca12",
    "37b349",
    "00aabb",
    "0e5a94",
    "b31e8d",
    "7a2d00"
  ],
  "Railscasts": [
    "2b2b2b",
    "272935",
    "3a4055",
    "5a647e",
    "d4cfc9",
    "e6e1dc",
    "f4f1ed",
    "f9f7f3",
    "da4939",
    "cc7833",
    "ffc66d",
    "a5c261",
    "519f50",
    "6d9cbe",
    "b6b3eb",
    "bc9458"
  ],
  "Seti UI": [
    "151718",
    "282a2b",
    "3B758C",
    "41535B",
    "43a5d5",
    "d6d6d6",
    "eeeeee",
    "ffffff",
    "Cd3f45",
    "db7b55",
    "e6cd69",
    "9fca56",
    "55dbbe",
    "55b5db",
    "a074c4",
    "8a553f"
  ],
  "Shapeshifter": [
    "f9f9f9",
    "e0e0e0",
    "ababab",
    "555555",
    "343434",
    "102015",
    "040404",
    "000000",
    "e92f2f",
    "e09448",
    "dddd13",
    "0ed839",
    "23edda",
    "3b48e3",
    "f996e2",
    "69542d"
  ],
  "Spacemacs": [
    "1f2022",
    "282828",
    "444155",
    "585858",
    "b8b8b8",
    "a3a3a3",
    "e8e8e8",
    "f8f8f8",
    "f2241f",
    "ffa500",
    "b1951d",
    "67b11d",
    "2d9574",
    "4f97d7",
    "a31db1",
    "b03060"
  ],
  "London Tube": [
    "231f20",
    "1c3f95",
    "5a5758",
    "737171",
    "959ca1",
    "d9d8d8",
    "e7e7e8",
    "ffffff",
    "ee2e24",
    "f386a1",
    "ffd204",
    "00853e",
    "85cebc",
    "009ddc",
    "98005d",
    "b06110"
  ],
  "Unikitty Dark": [
    "2e2a31",
    "4a464d",
    "666369",
    "838085",
    "9f9da2",
    "bcbabe",
    "d8d7da",
    "f5f4f7",
    "d8137f",
    "d65407",
    "dc8a0e",
    "17ad98",
    "149bda",
    "796af5",
    "bb60ea",
    "c720ca"
  ],
  "Unikitty Light": [
    "ffffff",
    "e1e1e2",
    "c4c3c5",
    "a7a5a8",
    "89878b",
    "6c696e",
    "4f4b51",
    "322d34",
    "d8137f",
    "d65407",
    "dc8a0e",
    "17ad98",
    "149bda",
    "775dff",
    "aa17e6",
    "e013d0"
  ],
  "Unikitty Reversible": [
    "2e2a31",
    "4b484e",
    "69666b",
    "878589",
    "a5a3a6",
    "c3c2c4",
    "e1e0e1",
    "ffffff",
    "d8137f",
    "d65407",
    "dc8a0e",
    "17ad98",
    "149bda",
    "7864fa",
    "b33ce8",
    "d41acd"
  ],
  "vice": [
    "17191E",
    "22262d",
    "3c3f4c",
    "383a47",
    "555e70",
    "8b9cbe",
    "B2BFD9",
    "f4f4f7",
    "ff29a8",
    "85ffe0",
    "f0ffaa",
    "0badff",
    "8265ff",
    "00eaff",
    "00f6d9",
    "ff3d81"
  ],
  "vulcan": [
    "041523",
    "122339",
    "003552",
    "7a5759",
    "6b6977",
    "5b778c",
    "333238",
    "214d68",
    "818591",
    "9198a3",
    "adb4b9",
    "977d7c",
    "977d7c",
    "977d7c",
    "9198a3",
    "977d7c"
  ],
  "Windows 10 Light": [
    "f2f2f2",
    "e5e5e5",
    "d9d9d9",
    "cccccc",
    "ababab",
    "767676",
    "414141",
    "0c0c0c",
    "c50f1f",
    "f9f1a5",
    "c19c00",
    "13a10e",
    "3a96dd",
    "0037da",
    "881798",
    "16c60c"
  ],
  "Windows 10": [
    "0c0c0c",
    "2f2f2f",
    "535353",
    "767676",
    "b9b9b9",
    "cccccc",
    "dfdfdf",
    "f2f2f2",
    "e74856",
    "c19c00",
    "f9f1a5",
    "16c60c",
    "61d6d6",
    "3b78ff",
    "b4009e",
    "13a10e"
  ],
  "Windows 95 Light": [
    "fcfcfc",
    "e0e0e0",
    "c4c4c4",
    "a8a8a8",
    "7e7e7e",
    "545454",
    "2a2a2a",
    "000000",
    "a80000",
    "fcfc54",
    "a85400",
    "00a800",
    "00a8a8",
    "0000a8",
    "a800a8",
    "54fc54"
  ],
  "Windows 95": [
    "000000",
    "1C1C1C",
    "383838",
    "545454",
    "7e7e7e",
    "a8a8a8",
    "d2d2d2",
    "fcfcfc",
    "fc5454",
    "a85400",
    "fcfc54",
    "54fc54",
    "54fcfc",
    "5454fc",
    "fc54fc",
    "00a800"
  ],
  "Windows High Contrast Light": [
    "fcfcfc",
    "e8e8e8",
    "d4d4d4",
    "c0c0c0",
    "7e7e7e",
    "545454",
    "2a2a2a",
    "000000",
    "800000",
    "fcfc54",
    "808000",
    "008000",
    "008080",
    "000080",
    "800080",
    "54fc54"
  ],
  "Windows High Contrast": [
    "000000",
    "1C1C1C",
    "383838",
    "545454",
    "a2a2a2",
    "c0c0c0",
    "dedede",
    "fcfcfc",
    "fc5454",
    "808000",
    "fcfc54",
    "54fc54",
    "54fcfc",
    "5454fc",
    "fc54fc",
    "008000"
  ],
  "Windows NT Light": [
    "ffffff",
    "eaeaea",
    "d5d5d5",
    "c0c0c0",
    "a0a0a0",
    "808080",
    "404040",
    "000000",
    "800000",
    "ffff00",
    "808000",
    "008000",
    "008080",
    "000080",
    "800080",
    "00ff00"
  ],
  "Windows NT": [
    "000000",
    "2a2a2a",
    "555555",
    "808080",
    "a1a1a1",
    "c0c0c0",
    "e0e0e0",
    "ffffff",
    "ff0000",
    "808000",
    "ffff00",
    "00ff00",
    "00ffff",
    "0000ff",
    "ff00ff",
    "008000"
  ],
  "Woodland": [
    "231e18",
    "302b25",
    "48413a",
    "9d8b70",
    "b4a490",
    "cabcb1",
    "d7c8bc",
    "e4d4c8",
    "d35c5c",
    "ca7f32",
    "e0ac16",
    "b7ba53",
    "6eb958",
    "88a4d3",
    "bb90e2",
    "b49368"
  ],
  "XCode Dusk": [
    "282B35",
    "3D4048",
    "53555D",
    "686A71",
    "7E8086",
    "939599",
    "A9AAAE",
    "BEBFC2",
    "B21889",
    "786DC5",
    "438288",
    "DF0002",
    "00A0BE",
    "790EAD",
    "B21889",
    "C77C48"
  ],
  "Zenburn": [
    "383838",
    "404040",
    "606060",
    "6f6f6f",
    "808080",
    "dcdccc",
    "c0c0c0",
    "ffffff",
    "dca3a3",
    "dfaf8f",
    "e0cf9f",
    "5f7f5f",
    "93e0e3",
    "7cb8bb",
    "dc8cc3",
    "000000"
  ]
};

export default colorSchemes;
